import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/participants";

const getLuckyDrawParticipants = (params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          uuid: params.uuid,
          search: params.search,
          showWinnerOnly: params.showWinnerOnly,
          orderBy: params.orderBy,
          limit: params.limit,
          skip: params.skip,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getLuckyDrawParticipants;
